import Link from "hooks/Link";
// import React from "react";
// import { Container } from "react-bootstrap";

// const PrimaryTabs = ({ tabs, active, setActive }) => {
//   return (
//     <>
//       <nav  className="primary-tabs">
//         {/* <Container> */}

//           <ul className="primary-tabs-inner">
//             {tabs.map((tab) => {
//               return (
//                 <>
//                 {tab === "Investor’s Pitch" ?
//                   <Link to={`/investors-pitch/Investor’s-Pitch`}>
//                     <li className={`primary-tab ${tab == active && "active"} `}>
//                       <button
//                         className="simple-button p-2"
//                         onClick={() => {
//                           setActive(tab);
//                         }}
//                       >
//                         Investor's Pitch
//                       </button>
//                     </li>
//                   </Link>
//                   :
//                   <Link to={`/investors-pitch/${tab}`}>
//                     <li className={`primary-tab ${tab == active && "active"} `}>
//                       <button
//                         className="simple-button p-2"
//                         onClick={() => {
//                           setActive(tab);
//                         }}
//                       >
//                         {tab}
//                       </button>
//                     </li>
//                   </Link>
//                 }

//                 </>
//               );
//             })}
//           </ul>
//         {/* </Container> */}
//       </nav>
//     </>
//   );
// };

// export default PrimaryTabs;



// expandable




import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

function PrimaryTabs({ tabs, active, setActive }) {
  return (
    <Navbar className="Investors-pitch-nav" expand="lg">
      {/* <Container> */}
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto link-container">
          {tabs.map((tab) => {
            return (
              <>
                {tab === "Investor’s Pitch" ?
                  <Link to={`/investors-pitch/Investor’s-Pitch`}>
                    <li className={`primary-tab ${tab == active && "active"} `}>
                      <button
                        className="simple-button p-2"
                        onClick={() => {
                          setActive(tab);
                        }}
                      >
                        Investor's Pitch
                      </button>
                    </li>
                  </Link>
                  :
                  <Link to={`/investors-pitch/${tab}`}>
                    <li className={`primary-tab ${tab == active && "active"} `}>
                      <button
                        className="simple-button p-2"
                        onClick={() => {
                          setActive(tab);
                        }}
                      >
                        {tab}
                      </button>
                    </li>
                  </Link>
                }

              </>
            );
          })}
        </Nav>
      </Navbar.Collapse>
      {/* </Container> */}
    </Navbar>
  );
}

export default PrimaryTabs;



